import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var Reporting =
/*#__PURE__*/
function () {
  function Reporting() {
    _classCallCheck(this, Reporting);
  }

  _createClass(Reporting, [{
    key: "GetOccupancyBy",
    value: function () {
      var _GetOccupancyBy = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(filter) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.post("/api/reporting/GetOccupancyReport", filter));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetOccupancyBy(_x) {
        return _GetOccupancyBy.apply(this, arguments);
      }

      return GetOccupancyBy;
    }()
  }, {
    key: "GetFilterBlockDefaults",
    value: function () {
      var _GetFilterBlockDefaults = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(reportid) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/reporting/GetFilterBlockDefaults/".concat(reportid)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetFilterBlockDefaults(_x2) {
        return _GetFilterBlockDefaults.apply(this, arguments);
      }

      return GetFilterBlockDefaults;
    }()
  }, {
    key: "GetZipCodes",
    value: function () {
      var _GetZipCodes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/reporting/GetZipCodes"));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetZipCodes() {
        return _GetZipCodes.apply(this, arguments);
      }

      return GetZipCodes;
    }()
  }, {
    key: "GetUnitOptions",
    value: function () {
      var _GetUnitOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/reporting/GetUnitOptions"));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetUnitOptions() {
        return _GetUnitOptions.apply(this, arguments);
      }

      return GetUnitOptions;
    }()
  }, {
    key: "GetRentAnalysis",
    value: function () {
      var _GetRentAnalysis = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(filter) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.post('/api/reporting/GetRentAnalysis', filter));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function GetRentAnalysis(_x3) {
        return _GetRentAnalysis.apply(this, arguments);
      }

      return GetRentAnalysis;
    }()
  }, {
    key: "GetStatementAnalysis",
    value: function () {
      var _GetStatementAnalysis = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(filter) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.post('/api/reporting/GetStatementAnalysis', filter));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function GetStatementAnalysis(_x4) {
        return _GetStatementAnalysis.apply(this, arguments);
      }

      return GetStatementAnalysis;
    }()
  }, {
    key: "GetVacancyReport",
    value: function () {
      var _GetVacancyReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(filter) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post('/api/reporting/GetVacancyReport', filter));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function GetVacancyReport(_x5) {
        return _GetVacancyReport.apply(this, arguments);
      }

      return GetVacancyReport;
    }()
  }, {
    key: "GetOccupancyByPropertyReport",
    value: function () {
      var _GetOccupancyByPropertyReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(filter) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.post('/api/reporting/GetOccupancyByPropertyReport', filter));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function GetOccupancyByPropertyReport(_x6) {
        return _GetOccupancyByPropertyReport.apply(this, arguments);
      }

      return GetOccupancyByPropertyReport;
    }()
  }, {
    key: "GetOccupancyMoveOutReport",
    value: function () {
      var _GetOccupancyMoveOutReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(filter) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.post('/api/reporting/GetOccupancyMoveOutReport', filter));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function GetOccupancyMoveOutReport(_x7) {
        return _GetOccupancyMoveOutReport.apply(this, arguments);
      }

      return GetOccupancyMoveOutReport;
    }()
  }, {
    key: "GetCongessionalDistrictReport",
    value: function () {
      var _GetCongessionalDistrictReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(filter) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.post('/api/reporting/GetCongessionalDistrictReport', filter));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function GetCongessionalDistrictReport(_x8) {
        return _GetCongessionalDistrictReport.apply(this, arguments);
      }

      return GetCongessionalDistrictReport;
    }()
  }, {
    key: "GetCongessionalDistrictReportByProperty",
    value: function () {
      var _GetCongessionalDistrictReportByProperty = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(filter) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.post('/api/reporting/GetCongessionalDistrictReportByProperty', filter));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function GetCongessionalDistrictReportByProperty(_x9) {
        return _GetCongessionalDistrictReportByProperty.apply(this, arguments);
      }

      return GetCongessionalDistrictReportByProperty;
    }()
  }, {
    key: "GetFinancialReportCard",
    value: function () {
      var _GetFinancialReportCard = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(filter) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", axios.post('/api/reporting/GetFinancialReportCard', filter));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function GetFinancialReportCard(_x10) {
        return _GetFinancialReportCard.apply(this, arguments);
      }

      return GetFinancialReportCard;
    }()
  }, {
    key: "GetAllCountiesWithFinancialReportRegion",
    value: function () {
      var _GetAllCountiesWithFinancialReportRegion = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(regionId) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", axios.get("/api/reporting/GetAllCountiesWithFinancialReportRegion/".concat(regionId)));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function GetAllCountiesWithFinancialReportRegion(_x11) {
        return _GetAllCountiesWithFinancialReportRegion.apply(this, arguments);
      }

      return GetAllCountiesWithFinancialReportRegion;
    }()
  }, {
    key: "SaveAllCountiesWithFinancialReportRegion",
    value: function () {
      var _SaveAllCountiesWithFinancialReportRegion = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(regionId, countyIds) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", axios.post("/api/reporting/SaveAllCountiesWithFinancialReportRegion/".concat(regionId), countyIds));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function SaveAllCountiesWithFinancialReportRegion(_x12, _x13) {
        return _SaveAllCountiesWithFinancialReportRegion.apply(this, arguments);
      }

      return SaveAllCountiesWithFinancialReportRegion;
    }()
  }, {
    key: "GetSpecialNeedsOccupancyReport",
    value: function () {
      var _GetSpecialNeedsOccupancyReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(filter) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", axios.post('/api/reporting/GetSpecialNeedsOccupancyReport', filter));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function GetSpecialNeedsOccupancyReport(_x14) {
        return _GetSpecialNeedsOccupancyReport.apply(this, arguments);
      }

      return GetSpecialNeedsOccupancyReport;
    }()
  }, {
    key: "GetSpecialNeedsVacancyDetailsReport",
    value: function () {
      var _GetSpecialNeedsVacancyDetailsReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(filter) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", axios.post('/api/reporting/GetSpecialNeedsVacancyDetailsReport', filter));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function GetSpecialNeedsVacancyDetailsReport(_x15) {
        return _GetSpecialNeedsVacancyDetailsReport.apply(this, arguments);
      }

      return GetSpecialNeedsVacancyDetailsReport;
    }()
  }, {
    key: "GetAvergageRentIncreaseHistory",
    value: function () {
      var _GetAvergageRentIncreaseHistory = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17(filter) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", axios.post('/api/reporting/GetAvergageRentIncreaseHistory', filter));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function GetAvergageRentIncreaseHistory(_x16) {
        return _GetAvergageRentIncreaseHistory.apply(this, arguments);
      }

      return GetAvergageRentIncreaseHistory;
    }()
  }, {
    key: "GetNOIReport",
    value: function () {
      var _GetNOIReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(filter) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", axios.post('/api/reporting/GetNOIReport', filter));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function GetNOIReport(_x17) {
        return _GetNOIReport.apply(this, arguments);
      }

      return GetNOIReport;
    }()
  }, {
    key: "GetEconomicOccupancyReport",
    value: function () {
      var _GetEconomicOccupancyReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19(filter) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", axios.post('/api/reporting/GetEconomicOccupancyReport', filter));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function GetEconomicOccupancyReport(_x18) {
        return _GetEconomicOccupancyReport.apply(this, arguments);
      }

      return GetEconomicOccupancyReport;
    }()
  }, {
    key: "GetAccountsPayableReport",
    value: function () {
      var _GetAccountsPayableReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20(filter) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", axios.post('/api/reporting/GetAccountsPayableReport', filter));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function GetAccountsPayableReport(_x19) {
        return _GetAccountsPayableReport.apply(this, arguments);
      }

      return GetAccountsPayableReport;
    }()
  }, {
    key: "GetOccupancySubmissionSummaryReport",
    value: function () {
      var _GetOccupancySubmissionSummaryReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21(filter) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", axios.post('/api/reporting/GetOccupancySubmissionSummaryReport', filter));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function GetOccupancySubmissionSummaryReport(_x20) {
        return _GetOccupancySubmissionSummaryReport.apply(this, arguments);
      }

      return GetOccupancySubmissionSummaryReport;
    }()
  }, {
    key: "GetCurrentLRAContacts",
    value: function () {
      var _GetCurrentLRAContacts = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22(filter) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", axios.post('/api/reporting/GetCurrentLRAContacts', filter));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function GetCurrentLRAContacts(_x21) {
        return _GetCurrentLRAContacts.apply(this, arguments);
      }

      return GetCurrentLRAContacts;
    }()
  }, {
    key: "GetComplianceModuleSummaryReport",
    value: function () {
      var _GetComplianceModuleSummaryReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23(filter) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", axios.post('/api/reporting/GetComplianceModuleSummaryReport', filter));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      function GetComplianceModuleSummaryReport(_x22) {
        return _GetComplianceModuleSummaryReport.apply(this, arguments);
      }

      return GetComplianceModuleSummaryReport;
    }()
  }, {
    key: "GetResyndicationReport",
    value: function () {
      var _GetResyndicationReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24(filter) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", axios.post('/api/reporting/GetResyndicationReport', filter));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function GetResyndicationReport(_x23) {
        return _GetResyndicationReport.apply(this, arguments);
      }

      return GetResyndicationReport;
    }()
  }, {
    key: "GetResidentRelationsReport",
    value: function () {
      var _GetResidentRelationsReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25(filter) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", axios.post('/api/reporting/GetResidentRelationReport', filter));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      function GetResidentRelationsReport(_x24) {
        return _GetResidentRelationsReport.apply(this, arguments);
      }

      return GetResidentRelationsReport;
    }()
  }, {
    key: "GetInsuranceClaimReport",
    value: function () {
      var _GetInsuranceClaimReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26(filter) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", axios.post('/api/reporting/GetInsuranceClaimReport', filter));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      function GetInsuranceClaimReport(_x25) {
        return _GetInsuranceClaimReport.apply(this, arguments);
      }

      return GetInsuranceClaimReport;
    }()
  }, {
    key: "GetStaffReport",
    value: function () {
      var _GetStaffReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27(filter) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", axios.post('/api/reporting/GetStaffReport', filter));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      function GetStaffReport(_x26) {
        return _GetStaffReport.apply(this, arguments);
      }

      return GetStaffReport;
    }()
  }, {
    key: "GetMHDCReviwerUsers",
    value: function () {
      var _GetMHDCReviwerUsers = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", axios.get('/api/reporting/GetMHDCReviwerUsers'));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      function GetMHDCReviwerUsers() {
        return _GetMHDCReviwerUsers.apply(this, arguments);
      }

      return GetMHDCReviwerUsers;
    }()
  }]);

  return Reporting;
}();

export default new Reporting();